export default "__VITE_ASSET__CUw$MRQ2__"